module.exports = __webpack_public_path__ + "static/media/se_ordforståelse.5167a5fe.mp4";